import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e79b6b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-content" }
const _hoisted_3 = { class: "top-content-c" }
const _hoisted_4 = { class: "top-content-left-c" }
const _hoisted_5 = { class: "contract-c" }
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = { class: "title-c" }
const _hoisted_8 = { class: "top-content-right-c" }
const _hoisted_9 = { class: "title-c" }
const _hoisted_10 = { class: "value-c" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-r" }, "人", -1))
const _hoisted_12 = { class: "title-c" }
const _hoisted_13 = { class: "value-c" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-r" }, "元", -1))
const _hoisted_15 = { class: "title-c" }
const _hoisted_16 = { class: "value-c" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-r" }, "元", -1))
const _hoisted_18 = { class: "title-c" }
const _hoisted_19 = { class: "value-c" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-r" }, "%", -1))
const _hoisted_21 = { class: "info-c" }
const _hoisted_22 = { class: "info-left-c" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "insurence",
  style: {"width":"950px","height":"200px"}
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "claimAmount",
  style: {"width":"460px","height":"300px"}
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "numberOfCase",
  style: {"width":"460px","height":"300px"}
}, null, -1))
const _hoisted_26 = { class: "info-right-c" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"margin-left":"8px","font-weight":"900"} }, "批量增人", -1))
const _hoisted_28 = { style: {"height":"100px","position":"relative"} }
const _hoisted_29 = { style: {"position":"absolute","left":"50%","top":"50%","transform":"translate(-50%, -50%)"} }
const _hoisted_30 = { style: {"line-height":"24px"} }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { key: 5 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 6 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  style: {"color":"black","position":"absolute","bottom":"0","right":"0","font-size":"14px"}
}
const _hoisted_43 = { style: {"line-height":"28px"} }
const _hoisted_44 = { class: "number-box" }
const _hoisted_45 = ["onClick"]

import { loginApi } from "@/api/login";
import { reactive, ref, onMounted, inject, onBeforeUnmount } from "vue";
import store from "@/store";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { message, Empty } from "ant-design-vue";
import { fmoney } from "@/utils/tools";
import { getOperationLog } from "@/api/operation";
import CheckContractInfo from "@/views/modules/CheckContractInfo.vue";
import { downloadFileByPos } from "@/api/pos";
import {
  echartsXAxis,
  echartsYAxis,
  echartsXAxisByPosAddAndReduce,
  echartsYAxisByPosAddAndReduce,
} from "@/utils/echartsDataTools";
import {
  getBasicInfo,
  getNormalData,
  getChartsInfo,
  getPosInfo,
} from "@/api/home";
type EChartsOption = echarts.EChartsOption;

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const checkContractInfo = ref(null);
const current = ref(1);
const helperFileList = ref([]);
const helperFileListAll = ref([]);
const router = useRouter();
var option: EChartsOption;
var option2: EChartsOption;
var option3: EChartsOption;
var option4: EChartsOption;
let echarts: any = inject("echarts");
let myChart: any = null;
let myChart3: any = null;
let myChart4: any = null;
const contractInfo = ref({
  contractName: "",
  contractDate: "",
  contractLogoUrl: "https://img.onehome.cn/new-hr-portal/5aS05YOP.png",
  claimAmount: "",
  estimateInsureFee: "",
  immediatePayoutRatio: "",
  insuredNum: "",
});
onMounted(() => {
  setTimeout(() => {
    // 在这里初始化依赖于 DOM 的库或组件
    getBasicData();
  });
});
onBeforeUnmount(() => {
  if (myChart) {
    myChart.dispose();
    myChart = null;
  }
  if (myChart3) {
    myChart3.dispose();
    myChart3 = null;
  }
  if (myChart4) {
    myChart4.dispose();
    myChart4 = null;
  }
});
const operationLogByHome = ref<any[]>([]);
const checkContractDetailInfo = () => {
  if (checkContractInfo.value) checkContractInfo.value.showModal();
};

const claimAmountCard = [
  {
    key: "claimAmount",
    tab: "理赔金额",
  },
  {
    key: "numberOfCase",
    tab: "案件数量",
  },
];

const getBasicData = () => {
  getBasicInfo()
    .then((res) => {
      contractInfo.value.contractName = res.data.contractBriefInfo.contractName;
      contractInfo.value.contractLogoUrl = res.data.logoUrl
        ? res.data.logoUrl
        : "https://img.onehome.cn/new-hr-portal/5aS05YOP.png";
      contractInfo.value.contractDate =
        res.data.contractBriefInfo.contractStartTime +
        "至" +
        res.data.contractBriefInfo.contractEndTime;
      helperFileListAll.value = res.data.helperFileList;
      for (let i = 0; i <= 4 && helperFileListAll.value[i] != undefined; i++) {
        helperFileList.value.push(helperFileListAll.value[i]);
      }
    })
    .catch();
  getNormalData()
    .then((res) => {
      contractInfo.value.claimAmount = String(res.data.claimAmount);
      contractInfo.value.estimateInsureFee = String(res.data.estimateInsureFee);
      contractInfo.value.immediatePayoutRatio = String(
        (res.data.immediatePayoutRatio * 100).toFixed(2)
      );
      contractInfo.value.insuredNum = String(res.data.insuredNum);
    })
    .catch();
  getChartsInfo()
    .then((res) => {
      setTimeout(() => {
        const claimAmountEchartsDom = document.getElementById("claimAmount");
        if (claimAmountEchartsDom) {
          myChart3 = echarts.init(claimAmountEchartsDom);
          option3 = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985",
                },
              },
            },
            xAxis: {
              type: "category",
              data: echartsXAxis(res.data.claimAmountStatistics),
              axisTick: {
                alignWithLabel: true,
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                show: false,
              },
            },
            grid: {
              left: "3%",
              top: 20,
              bottom: 30,
              containLabel: true,
            },
            series: [
              {
                data: echartsYAxis(res.data.claimAmountStatistics),
                type: "bar",
                showBackground: true,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#42b983" },
                    { offset: 0.5, color: "#A8DBB4" },
                    { offset: 1, color: "#DAF0E0" },
                  ]),
                },
                emphasis: {
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#DAF0E0" },
                      { offset: 0.7, color: "#8ED0A0" },
                      { offset: 1, color: "#42b983" },
                    ]),
                  },
                },
                barWidth: "60%",
              },
            ],
          };
          option3 && myChart3.setOption(option3);

          myChart4 = echarts.init(document.getElementById("numberOfCase"));
          option4 = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985",
                },
              },
            },
            xAxis: {
              type: "category",
              data: echartsXAxis(res.data.claimCaseStatistics),
              axisTick: {
                alignWithLabel: true,
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                show: false,
              },
            },
            grid: {
              left: "3%",
              top: 20,
              bottom: 30,
              containLabel: true,
            },
            series: [
              {
                data: echartsYAxis(res.data.claimCaseStatistics),
                type: "bar",
                showBackground: true,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#1677ff" },
                    { offset: 0.5, color: "#69b1ff" },
                    { offset: 1, color: "#bae0ff" },
                  ]),
                },
                emphasis: {
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#bae0ff" },
                      { offset: 0.7, color: "#4096ff" },
                      { offset: 1, color: "#1677ff" },
                    ]),
                  },
                },
              },
            ],
          };
          option4 && myChart4.setOption(option4);
        }
      }, 200);
    })
    .catch();
  getPosInfo()
    .then((res) => {
      setTimeout(() => {
        const insurenceEchartsDom = document.getElementById("insurence");
        if (insurenceEchartsDom) {
          myChart = echarts.init(insurenceEchartsDom);
          option = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985",
                },
              },
            },
            legend: {
              show: true,
              right: "50px",
              orient: "vertical",
              type: "scroll",
              top: "middle",
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: echartsXAxisByPosAddAndReduce(
                  res.data.addMonthStatistics,
                  res.data.reduceMonthStatistics
                ),
                axisLine: {
                  onZero: false,
                },
              },
            ],
            yAxis: {
              type: "value",
              splitLine: {
                show: false,
              },
            },
            grid: {
              bottom: 30,
              borderWidth: 2,
              top: "30px",
              left: "50px",
              right: "20%",
            },
            series: [
              {
                name: "月度增人",
                data: echartsYAxisByPosAddAndReduce(
                  res.data.addMonthStatistics,
                  res.data.reduceMonthStatistics
                ),
                type: "line",
                smooth: true,
                lineStyle: {
                  width: 0,
                },
                showSymbol: false,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#1677ff",
                    },
                    {
                      offset: 1,
                      color: "#bae0ff",
                    },
                  ]),
                },
              },
              {
                name: "月度减人",
                data: echartsYAxisByPosAddAndReduce(
                  res.data.reduceMonthStatistics,
                  res.data.addMonthStatistics
                ),
                type: "line",
                smooth: true,
                lineStyle: {
                  width: 0,
                },
                showSymbol: false,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#42b983",
                    },
                    {
                      offset: 1,
                      color: "#DAF0E0",
                    },
                  ]),
                },
              },
            ],
          };
          option && myChart.setOption(option);
        }
      }, 200);
    })
    .catch();
  getOperationLog({})
    .then((reso) => {
      let data = reso.data.dataList;
      for (let i = 0; data.length > 2 ? i <= 2 : i < data.length; i++) {
        operationLogByHome.value.push(data[i]);
      }
    })
    .catch();
};
const getDownloadUrl = async (record: any) => {
  let paramater = {
    id: record.attachmentId,
    duration: 600,
  };
  let res: any = await downloadFileByPos(paramater);
  if (res.code == 200) {
    let a = document.createElement("a");
    a.href = res.data;
    a.click();
    message.success("下载成功");
  } else {
    message.error(res.msg);
  }
};
const handleOpenFile = (url: string) => {
  window.open(url);
};
const handleChangeCurrent = (pageNum: any) => {
  helperFileList.value = [];
  for (
    let i = pageNum * 5 - 5;
    i <= pageNum * 5 - 1 && helperFileListAll.value[i] != undefined;
    i++
  ) {
    helperFileList.value.push(helperFileListAll.value[i]);
  }
};
const toAddPos = () => {
  store.dispatch("setIsShowAddPosModal", true);
  router.push({ name: "posList" });
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_image, {
                src: contractInfo.value.contractLogoUrl,
                preview: false,
                style: {"max-width":"150px","max-height":"60px"}
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(contractInfo.value.contractName) + " ", 1),
                _createVNode(_component_a_button, {
                  type: "primary",
                  style: {"margin-left":"16px"},
                  onClick: checkContractDetailInfo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看保障方案")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, "有效期：" + _toDisplayString(contractInfo.value.contractDate), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                title: _withCtx(() => [
                  _createTextVNode("截止当前时间本年度保单在保人数")
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" 在保人数 "),
                    _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(fmoney)(contractInfo.value.insuredNum)) + " ", 1),
                _hoisted_11
              ])
            ]),
            _createVNode(_component_a_divider, {
              type: "vertical",
              style: {"height":"60px","background-color":"42b983"}
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                title: _withCtx(() => [
                  _createTextVNode("截至当前时间系统预估保费，最终金额请以保险公司保费账单为准")
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(" 预估保费 "),
                    _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_unref(fmoney)(contractInfo.value.estimateInsureFee)), 1),
                _hoisted_14
              ])
            ]),
            _createVNode(_component_a_divider, {
              type: "vertical",
              style: {"height":"60px","background-color":"42b983"}
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                title: _withCtx(() => [
                  _createTextVNode("截至当前时间，本年度保单已赔付的理赔金额")
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(" 赔付金额 "),
                    _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(fmoney)(contractInfo.value.claimAmount)), 1),
                _hoisted_17
              ])
            ]),
            _createVNode(_component_a_divider, {
              type: "vertical",
              style: {"height":"60px","background-color":"42b983"}
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                title: _withCtx(() => [
                  _createTextVNode("截至当前时间，本年度保单的即时综合赔付率")
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createTextVNode(" 即时赔付率 "),
                    _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(contractInfo.value.immediatePayoutRatio), 1),
                _hoisted_20
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_a_card, { bodyStyle: { padding: '16px 24px 0px 24px' } }, {
            title: _withCtx(() => [
              _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                title: _withCtx(() => [
                  _createTextVNode("截止当前时间每月增减人数，不含期初投保人员")
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 月度增减人数 "),
                  _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    style: {"margin-top":"16px","height":"383px"},
                    bodyStyle: { padding: '16px 24px 0px 24px' }
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                        title: _withCtx(() => [
                          _createTextVNode("截止当前时间每月理赔案件赔付金额")
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" 月度赔付金额 "),
                          _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    style: {"margin-top":"16px","height":"383px"},
                    bodyStyle: { padding: '16px 24px 0px 24px' }
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                        title: _withCtx(() => [
                          _createTextVNode("截止当前时间每月理赔案件申请数量")
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" 月度理赔案件 "),
                          _createVNode(_unref(InfoCircleOutlined), { class: "title-icon-c" })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_a_card, {
            title: "快捷入口",
            style: {"height":"180px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { class: "quick-entry-c" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 12,
                    class: "quick-entry-col-c"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_image, {
                        src: "https://img.onehome.cn/new-hr-portal/posAdd.png",
                        preview: false
                      }),
                      _createElementVNode("a", {
                        style: {"margin-left":"8px","font-weight":"900"},
                        onClick: toAddPos
                      }, "单人增人")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                class: "quick-entry-c",
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 12,
                    class: "quick-entry-col-c"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_image, {
                        src: "https://img.onehome.cn/new-hr-portal/posBatchAdd.png",
                        preview: false
                      }),
                      _createVNode(_component_router_link, { to: { name: 'posBatchAdd' } }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, {
            title: "操作日志",
            class: "operation-c"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  (operationLogByHome.value.length == 0)
                    ? (_openBlock(), _createBlock(_component_a_empty, {
                        key: 0,
                        image: _unref(Empty).PRESENTED_IMAGE_SIMPLE,
                        imageStyle: { height: '30px' }
                      }, null, 8, ["image"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationLogByHome.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createTextVNode(_toDisplayString(item.operationDate) + "  ", 1),
                      (item.operationCode == 'EXPORT_POS')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createTextVNode(" 导出了 "),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (getDownloadUrl(item))
                            }, _toDisplayString(item.attachmentName), 9, _hoisted_32)
                          ]))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'EXPORT_CLAIM')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                            _createTextVNode(" 导出了 "),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (getDownloadUrl(item))
                            }, _toDisplayString(item.attachmentName), 9, _hoisted_34)
                          ]))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'POS_REDUCE')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "对" + _toDisplayString(item.targetUserNames) + "进行单人退保操作", 1))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'POS_ADD')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "对" + _toDisplayString(item.targetUserNames) + "进行单人投保操作", 1))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'CHANGE_POS_LEVEL')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "对" + _toDisplayString(item.targetUserNames) + "进行了层级变更", 1))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'UPLOAD_POS_BATCH_ADD')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                            _createTextVNode(" 上传了批量投保文件 "),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (getDownloadUrl(item))
                            }, _toDisplayString(item.attachmentName), 9, _hoisted_39)
                          ]))
                        : _createCommentVNode("", true),
                      (item.operationCode == 'UPLOAD_POS_BATCH_REDUCE')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _createTextVNode(" 上传了批量退保文件 "),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (getDownloadUrl(item))
                            }, _toDisplayString(item.attachmentName), 9, _hoisted_41)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_router_link, { to: { name: 'operationLog' } }, {
                  default: _withCtx(() => [
                    (operationLogByHome.value.length != 0)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_42, "查看更多"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, {
            title: "帮助信息",
            class: "helper-c"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(helperFileList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row-c",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_44, _toDisplayString((current.value - 1) * 5 + index + 1), 1),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (handleOpenFile(item.url))
                    }, _toDisplayString(item.name), 9, _hoisted_45)
                  ]))
                }), 128))
              ]),
              _createVNode(_component_a_pagination, {
                style: {"position":"absolute","right":"16px","bottom":"20px"},
                size: "small",
                current: current.value,
                "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
                total: helperFileListAll.value.length,
                pageSize: 5,
                "show-less-items": "",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (handleChangeCurrent(current.value)))
              }, null, 8, ["current", "total"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(CheckContractInfo, {
      ref_key: "checkContractInfo",
      ref: checkContractInfo
    }, null, 512)
  ], 64))
}
}

})